import { useTranslation } from '@frontend/i18n';
import { settingsTrackingIds } from '@frontend/schedule-helpers';
import { SettingsLink, useSettingsNavigate } from '@frontend/settings-routing';
import { SettingsGroup } from '@frontend/settings-ui';
import { IndexRow } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../../hooks/use-scheduling-location-info';

export const ManageMultiScheduleDefinitionTemplatesPage = () => {
  const { t } = useTranslation('schedule-settings');
  const { navigate } = useSettingsNavigate();

  const { selectedLocationIds, getScopeName } = useSchedulingLocationInfo();

  const navigateTo = (locationId: string) => {
    const route = '/schedule/schedule-definition-templates/:locationId';

    navigate({
      to: route,
      params: { locationId: locationId ?? '' },
    });
  };

  return (
    <SettingsGroup title={t('Location Settings')}>
      <IndexRow>
        {selectedLocationIds?.map((locationId) => {
          if (!locationId) return null;
          return (
            <IndexRow.Item
              key={locationId}
              as={SettingsLink}
              to='/schedule/schedule-definition-templates/:locationId'
              onClick={() => navigateTo(locationId)}
              trackingId={settingsTrackingIds.scheduleDefinitionTemplatesRowItem}
            >
              <IndexRow.Item.Title>{getScopeName(locationId)}</IndexRow.Item.Title>
            </IndexRow.Item>
          );
        })}
      </IndexRow>
    </SettingsGroup>
  );
};
